import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import NavBar from "../general/navBar";
import france from "../../assets/img/illu/france.png";
const Presence = () => {
  return (
    <section className="presence-section">
      <article className="left-content">
        <img src={france} alt="" />
      </article>

      <article className="right-content">
        <p className="tag green">Nos agences d’intérim en France</p>
        <h2>L’intérim nouvelle génération</h2>
        <p>
          On combine la proximité d’un ancrage local à la réactivité d’une
          solution digitale,
          <br />
          pour être là où vous avez besoin de nous.
        </p>
        <div className="link-container">
          <i
            class="fa-solid fa-arrow-right fa-lg"
            style={{ color: "#18c3ba" }}
          ></i>
          <Link className="nav-links link green" to="/agency/#agency-hero">
            Trouver l’agence la plus proche
          </Link>
        </div>
      </article>
    </section>
  );
};

export default Presence;
